<template lang="pug">
    v-layout(wrap class="m-list-objects")
        v-flex(xs12)
            m-list(v-bind="$attrs" v-on="$listeners" title="")
                template(#title="")
                    slot(name="title" v-if="$slots.title")
                    template(v-else) {{$t(`modules.lists.${name}.subheading`, {num: $attrs.pagination.totalItems})}}

                template(#template="{item, index}")
                    m-card-object(:item="item" :key="`${index}-${item.name}`" class="content-border-area" :isDashboard="isDashboard")
</template>

<script>
    import MCardObject from "@modules/cards/concrete/m-card-object";
    import baseList from "@mixins/components/modules/lists/base";

    let name = 'm-list-objects';
    export default {
        name: name,
        mixins: [baseList],
        components: {MCardObject},
        props: {
            name: {
                type: String,
                default: name
            },
            isDashboard: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss">
    .m-list-objects {
        .content-border-area {
            margin-bottom: 1rem;
        }
        .v-list {
            background: none;

            .e-link-nav {
                white-space: nowrap;
                overflow: hidden;
                width: 100%;
                text-overflow: ellipsis;
            }
            .e-typography-heading-3 {
                text-overflow: ellipsis;
            }
        }
    }
</style>
